import { HorizontalScrollObserver } from "./HorizontalScrollObserver";

export function observeHorizontalScroll(ref: HTMLElement) {
    let observer = new HorizontalScrollObserver();
    observer.observe(ref);
    return {
        scrollToSelected: () => observer.scrollToSelected("smooth"),

        unobserve: () => observer.dispose()
    };
}
